module.exports = __webpack_public_path__ + "img/purple-2.f9371c44.png";